import BoldEditorial from './BoldEditorial/BoldEditorial';
import Sakura from './Sakura/Sakura';
import Provence from './Provence/Provence';
import Botanica from './Botanica/Botanica';
import Velvet from './Velvet/Velvet';
import Arctic from './Arctic/Arctic';
import Gatsby from './Gatsby/Gatsby';
import Aquarelle from './Aquarelle/Aquarelle';
import Ivory from './Ivory/Ivory';
import Rustico from './Rustico/Rustico';
import Cosmos from './Cosmos/Cosmos';
import Ultramarin from './Ultramarin/Ultramarin';
import Graphite from './Graphite/Graphite';
import Amethyst from './Amethyst/Amethyst';
import Organica from './Organica/Organica';
import Amorika from './Amorika/Amorika';
import Voyage from './Voyage/Voyage';
import Lemon from './Lemon/Lemon';
import Alarus from './Alarus/Alarus';
import Rustic from './Rustic/Rustic';
import OnaSkazalaDa from './OnaSkazalaDa/OnaSkazalaDa';
import Flora from './Flora/Flora';

/**
 * Registry: template_slug → React component
 * Each component receives: { project, design, isPreview }
 */
const TEMPLATE_REGISTRY = {
  BoldEditorial,
  Sakura,
  Provence,
  Botanica,
  Velvet,
  Arctic,
  Gatsby,
  Aquarelle,
  Ivory,
  Rustico,
  Cosmos,
  Ultramarin,
  Graphite,
  Amethyst,
  Organica,
  Amorika,
  Voyage,
  Lemon,
  Alarus,
  Rustic,
  OnaSkazalaDa,
  Flora,
};

export default TEMPLATE_REGISTRY;
